(function () {
  'use strict';

  function initMobileMenu() {
    var button = document.querySelector('.savebigontires-mobile-menu-btn, .menu-toggle');
    var nav = document.querySelector('#MobileNav, .mobile-nav');

    if (!button || !nav || nav.dataset.sbotMenuReady === '1') return;

    nav.dataset.sbotMenuReady = '1';
    button.dataset.sbotMenuReady = '1';

    var overlay = document.querySelector('.mobile-nav-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'mobile-nav-overlay';
      document.body.appendChild(overlay);
    }

    var header = nav.querySelector('.mobile-nav-header');
    if (!header) {
      header = document.createElement('div');
      header.className = 'mobile-nav-header';
      header.innerHTML = '<strong>Menu</strong><button type="button" class="mobile-nav-close" aria-label="Close menu">×</button>';
      nav.insertBefore(header, nav.firstChild);
    }

    var closeButton = header.querySelector('.mobile-nav-close');

    function setMenuOpen(open) {
      nav.classList.toggle('open', open);
      overlay.classList.toggle('active', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (window.scrollLockManager) {
        if (open) window.scrollLockManager.lock('hamburger-menu');
        else window.scrollLockManager.unlock('hamburger-menu');
      } else {
        document.body.style.overflow = open ? 'hidden' : '';
      }
    }

    function collapseAllDropdowns() {
      nav.querySelectorAll('.mobile-nav--dropdown, .mobile-nav--dropdown-grandchild').forEach(function (dropdown) {
        dropdown.classList.remove('expanded');
        dropdown.style.maxHeight = '0';
      });

      nav.querySelectorAll('.mobile-nav--button').forEach(function (dropdownButton) {
        dropdownButton.classList.remove('expanded');
        dropdownButton.setAttribute('aria-expanded', 'false');
      });
    }

    collapseAllDropdowns();
    setMenuOpen(false);

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMenuOpen(!nav.classList.contains('open'));
    });

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        setMenuOpen(false);
      });
    }

    overlay.addEventListener('click', function () {
      setMenuOpen(false);
    });

    nav.querySelectorAll('.mobile-nav--button').forEach(function (dropdownButton) {
      dropdownButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var dropdown = dropdownButton.nextElementSibling;
        if (!dropdown) return;

        var open = !dropdown.classList.contains('expanded');
        dropdown.classList.toggle('expanded', open);
        dropdown.style.maxHeight = open ? dropdown.scrollHeight + 'px' : '0';
        dropdownButton.classList.toggle('expanded', open);
        dropdownButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    nav.querySelectorAll('a.mobile-nav--link').forEach(function (link) {
      link.addEventListener('click', function () {
        var parent = link.parentElement;
        var hasDropdown = parent && parent.querySelector('.mobile-nav--button');
        if (!hasDropdown) setMenuOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('open')) {
        setMenuOpen(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu, { once: true });
  } else {
    initMobileMenu();
  }
})();